import { useEffect, useState } from 'react';
import { Form, Dropdown } from 'semantic-ui-react';
import { connect } from 'react-redux';
import * as actions from '../../redux/actions';
import * as selectors from '../../redux/selectors';
import { bindActionCreators } from 'redux';

const FirmDropDown = ({
  getItemsForFirms,
  getFirmsForLookup,
  options,
  formik,
  value,
  error,
  label,
  multiple,
  id,
  name,
}) => {
  console.log('firmDropDown', { options });

  useEffect(() => {
    getFirmsForLookup();
  }, []);

  useEffect(() => {
    if (!value || !Array.isArray(value)) {
      return;
    }
    getItemsForFirms(value);
  }, [value]);

  const [selection, setSelection] = useState(value || []);

  const handleChange = (e, { name, value }) => {
    console.log({ value });
    let first = value;

    if (Array.isArray(value) && value.length > 0) {
      first = value[0];
    }

    formik.setFieldValue(name, multiple ? [first] : first);
    setSelection([first]);
  };

  return (
    <Form.Field error={Boolean(error)}>
      <label>{label}</label>
      <Dropdown
        fluid
        multiple={multiple}
        search
        selection
        clearable
        selected={selection}
        key={id ? id + '-' + name : name}
        options={options}
        id={name}
        label={label}
        name={name}
        value={value}
        onChange={(e, d) => handleChange(e, d)}
      />
    </Form.Field>
  );
};

const mapStateToProps = state => ({ options: selectors.firms.firmLookupOptions(state) });

const mapDispatchToProps = dispatch => ({
  getItemsForFirms: bindActionCreators(actions.adSlot.getItemsForFirms, dispatch),
  getFirmsForLookup: bindActionCreators(actions.firm.getFirmsForLookup, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(FirmDropDown);
